import React from 'react';
import '../css/site.css';
import '../css/w3.css';
import { useNavigate } from 'react-router-dom';
import logo from '../img/logo.png';


const TopMenu = () => {

    const navigate = useNavigate();
    const handleHomeClick = () => navigate('/');
    const handleAboutClick = () => navigate('/about');
    const handleBlogClick = () => navigate('/blog');
    const handlePrivacyClick = () => navigate('/privacy');
    const handleBase64ToImg = () => navigate('/base64-to-image-conversion');
    const HandleImgToBase64 = () => navigate('/image-to-base64-conversion');
    const handleBase64ToAscii = () => navigate('/base64-to-ascii-conversion');
    const handleAsciiToBase64 = () => navigate('/ascii-to-base64-conversion');
    const handleJsonminifier = () => navigate('/json-minifier');
    const handleXmlminifier = () => navigate('/xml-minifier');
    const handleHtmlminifier = () => navigate('/html-minifier');
    const handleCssminifier = () => navigate('/css-minifier');
    const handleJsminifier = () => navigate('/javascript-minifier');
    const handleJsontoxml = () => navigate('/json-to-xml-convertor');
    const handleXmltojson = () => navigate('/xml-to-json-convertor');
    const handleXmlformatter = () => navigate('/xml-formatter');
    const handleHtmlformatter = () => navigate('/html-formatter');
    const handleSqlformatter = () => navigate('/sql-formatter');
    const handleJsontostring = () => navigate('/json-to-string-convertor');
    const handleStringToJson = () => navigate('/string-to-json-convertor');
    const handleJsonToHtml = () => navigate('/json-to-html-convertor');
    const handleHtmlColorCodes = () => navigate('/html-color-codes');
    const handleJsonFormatter = () => navigate('/');
    const jwtdecodeClick = () => navigate('/jwt-decode');

    const navHandler = (e, callback) => {
    if (e.ctrlKey || e.metaKey || e.button === 1) return; // let browser handle new tab
    e.preventDefault();
    callback();
};


    return (
        <>
            {/* Start Main Menu */}
            <nav className="mainmenu-nav" id="mobilemenu-popup">
                <div className="d-block d-lg-none">
                    <div className="mobile-nav-header">
                        <div className="mobile-nav-logo">
                            <a href="/">
                                <img className="light-mode" src={logo} alt="Site Logo" />
                                <img className="dark-mode" src={logo} alt="Site Logo" />
                            </a>
                        </div>
                        <button className="mobile-menu-close" data-bs-dismiss="offcanvas">
                            <i className="fa fa-times"></i>
                        </button>
                    </div>
                </div>

                <ul className="mainmenu">
                    <li className="menu-item-open cursor-pointer">
                        <a
                            href="/"
                            onClick={(e) => {
                                if (e.ctrlKey || e.metaKey || e.button === 1) return; // let browser handle new tab
                                e.preventDefault();
                                handleHomeClick();
                            }}
                            className="active"
                        >
                            Home
                        </a>
                    </li>

                    <li className="menu-item-has-children">
                        <a href="#">Convertor</a>
                        <ul className="main-submenu">
                            <li><a href="/json-to-xml-convertor" onClick={(e) => navHandler(e, handleJsontoxml)}>JSON to XML</a></li>
                            <li><a href="/xml-to-json-convertor" onClick={(e) => navHandler(e, handleXmltojson)}>XML to JSON</a></li>
                            <li><a href="/json-to-string-convertor" onClick={(e) => navHandler(e, handleJsontostring)}>JSON to STRING</a></li>
                            <li><a href="/string-to-json-convertor" onClick={(e) => navHandler(e, handleStringToJson)}>STRING TO JSON</a></li>
                            <li><a href="/json-to-html-convertor" onClick={(e) => navHandler(e, handleJsonToHtml)}>JSON TO HTML</a></li>
                        </ul>
                    </li>

                    <li className="menu-item-has-children">
                        <a href="#">Minifier</a>
                        <ul className="main-submenu">
                            <li><a href="/json-minifier" onClick={(e) => navHandler(e, handleJsonminifier)}>JSON Minifier</a></li>
                            <li><a href="/xml-minifier" onClick={(e) => navHandler(e, handleXmlminifier)}>XML Minifier</a></li>
                            <li><a href="/html-minifier" onClick={(e) => navHandler(e, handleHtmlminifier)}>HTML Minifier</a></li>
                            <li><a href="/css-minifier" onClick={(e) => navHandler(e, handleCssminifier)}>CSS Minifier</a></li>
                            <li><a href="/javascript-minifier" onClick={(e) => navHandler(e, handleJsminifier)}>JavaScript Minifier</a></li>
                        </ul>
                    </li>

                    <li className="menu-item-has-children">
                        <a href="#">Formatter</a>
                        <ul className="main-submenu">
                            <li><a href="/" onClick={(e) => navHandler(e, handleJsonFormatter)}>JSON Formatter</a></li>
                            <li><a href="/xml-formatter" onClick={(e) => navHandler(e, handleXmlformatter)}>XML Formatter</a></li>
                            <li><a href="/html-formatter" onClick={(e) => navHandler(e, handleHtmlformatter)}>HTML Formatter</a></li>
                            <li><a href="/sql-formatter" onClick={(e) => navHandler(e, handleSqlformatter)}>SQL Formatter</a></li>
                            <li><a href="/html-color-codes" onClick={(e) => navHandler(e, handleHtmlColorCodes)}>HTML Color Codes</a></li>
                        </ul>
                    </li>

                    <li className="menu-item-has-children">
                        <a href="#">Base 64 Tools</a>
                        <ul className="main-submenu">
                            <li><a href="/base64-to-image-conversion" onClick={(e) => navHandler(e, handleBase64ToImg)}>Base64 To Image</a></li>
                            <li><a href="/image-to-base64-conversion" onClick={(e) => navHandler(e, HandleImgToBase64)}>Image To Base64</a></li>
                            <li><a href="/base64-to-ascii-conversion" onClick={(e) => navHandler(e, handleBase64ToAscii)}>Base64 To ASCII</a></li>
                            <li><a href="/ascii-to-base64-conversion" onClick={(e) => navHandler(e, handleAsciiToBase64)}>ASCII To Base64</a></li>
                            <li><a href="/jwt-decode" onClick={(e) => navHandler(e, jwtdecodeClick)}>JWT Decode</a></li>
                        </ul>
                    </li>

                    <li className="menu-item-open cursor-pointer">
                        <a href="/blog" onClick={(e) => navHandler(e, handleBlogClick)}>Blog</a>
                    </li>
                    <li className="menu-item-open cursor-pointer">
                        <a href="/about" onClick={(e) => navHandler(e, handleAboutClick)}>About</a>
                    </li>
                    <li className="menu-item-open cursor-pointer">
                        <a href="/privacy" onClick={(e) => navHandler(e, handlePrivacyClick)}>Privacy</a>
                    </li>
                </ul>
            </nav>

            {/* Start Main Menu */}
        </>
    );
};

export default TopMenu;